module.exports = __webpack_public_path__ + "static/media/epfl_me.0a70fd7f.jpg";